'use client'
import { useContext } from 'react'
import { ConfigContext, useTranslation } from '../../context/ConfigContext'
import { ModalContext, ModalContextType } from '../../context/ModalContext'
import { Button } from '../Button/Button'
import ModalCarving from '../Modal/ModalCarving'
import CarvingPreview from './CarvingPreview'
import { isSellingProductOnline } from '../../utils/Product.utils'

type ProductConfigurationCarvingProps = {
  product: Product
  selectedVariant: Variant | null
  carvingValue?: Carving

  onChange: (value?: Carving) => void
}

const ProductConfigurationCarving = ({
  product,
  selectedVariant,
  carvingValue,
  onChange,
}: ProductConfigurationCarvingProps) => {
  const { addModal, removeModal } = useContext(ModalContext) as ModalContextType
  const t = useTranslation()

  const isOnStock = (): boolean => {
    if (product.__typename === 'ConfigurableProduct') {
      return selectedVariant?.product?.stock_status === 'IN_STOCK'
    }

    if (product.__typename === 'SimpleProduct') {
      return product.stock_status === 'IN_STOCK'
    }

    return false
  }

  const isEngravable = product.gravure ?? false
  const { isEcommerce } = useContext(ConfigContext)
  const isSelling = selectedVariant?.product
    ? isSellingProductOnline(selectedVariant.product, isEcommerce())
    : isSellingProductOnline(product, isEcommerce())

  if (!isOnStock() || !isEngravable || !isSelling) {
    return null
  }

  if (carvingValue) {
    return (
      <CarvingPreview
        {...carvingValue}
        onEdit={() => {
          const uuid = crypto.randomUUID()
          addModal({
            uuid,
            component: (
              <ModalCarving
                uuid={uuid}
                product={product}
                initialValue={carvingValue}
                onConfirm={(value) => {
                  onChange(value)
                  removeModal(uuid)
                }}
                onRemove={() => {
                  onChange(undefined)
                  removeModal(uuid)
                }}
              />
            ),
          })
        }}
      />
    )
  }

  return (
    <Button
      classname='border-black carving-button'
      label={t('Add engraving', {}, false)}
      style='light'
      onClick={() => {
        const uuid = crypto.randomUUID()
        addModal({
          uuid,
          component: (
            <ModalCarving
              uuid={uuid}
              product={product}
              initialValue={carvingValue}
              onConfirm={(value) => {
                onChange(value)
                removeModal(uuid)
              }}
              onRemove={() => {}}
            />
          ),
        })
      }}
    />
  )
}

export default ProductConfigurationCarving
